export const DEFAULT_CREATE_MODAL_PROPS = {
  open: false,
  props: null
};

export const ADVANCED_HISTORY_EXAMINATION_ID = 9;
